export default __webpack_public_path__ + "static/justright-d7fcbea9a91f89f1b40ce8fc62f16187.png";